export default __webpack_public_path__ + "static/media/filter-icon.168202e8.svg";